import React, { useState } from 'react';
import FullVosImage from './FullDashboardVosImage';
interface VosModalProps {
    week: string;
    downloadLink: string;
    imageName: string;
}
const VosModal = ({ week, downloadLink, imageName }: VosModalProps): React.ReactElement => {
    const [showModal, setShowModal] = useState(false);
    const handleOnClick = (): void => {
        setShowModal(!showModal);
    };
    return (
        <>
            <div onClick={handleOnClick} className="GridViewItem-Edit-Container">
                <span style={{marginLeft:'15px', marginTop:'10px'}} className="UsersItem-Link">{week}</span>
            </div>
            {showModal && (
                <FullVosImage
                    onClickShow={() => setShowModal(true)}
                    show={showModal}
                    onClickHide={handleOnClick}
                    image={downloadLink}
                    imageName={imageName}
                />
            )}
        </>
    );
};
export default VosModal;
